import styled, { keyframes } from 'styled-components'

import breakpoints from '../constants/breakpoints'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const slideTop = keyframes`
  to {
    transform: translateY(0);
  }
`

const AboutLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 75vw;
  margin-left: auto;
  padding: 5% 5vw 8% 0;

  @media (max-width: ${breakpoints.screenLG}) {
    width: 85vw;
  }

  @media (max-width: ${breakpoints.screenMD}) {
    width: 100vw;
    padding: 5% 9vw 8%;
  }

  .text {
    margin-bottom: 5%;
    opacity: 0;
    transform: translateY(8vh);
    animation: ${fadeIn} 0.6s ease-out forwards,
      ${slideTop} 1.6s cubic-bezier(0.02, 0.98, 0.36, 1) forwards;

    :nth-child(1) {
      animation-delay: 1.1s;
    }

    :nth-child(2) {
      animation-delay: 1.15s;
    }

    :nth-child(3) {
      animation-delay: 1.2s;
    }
  }
`

export { AboutLayout }
